module.exports = __webpack_public_path__ + "img/impact_challenges_calendar.9c72a1ce.png";